import Swiper from './../imports/import-swiper';


export default ()=>{
  const container = document.querySelector('.w-gallery__slider');
  const wellnessPage = document.querySelector(".page-template-template-wellness");
  if (container) {
    const slides = container.querySelectorAll(".swiper-slide");
    slides.length > 1 ? runSliderSwipe(): false;
    changeBottomHeight();
    hidelist();
  }
  if (wellnessPage) {
    hideFeaturedList();
  }
  

  function runSliderSwipe(){
    let parent = container.closest('.w-gallery');
    let current = parent.querySelector('.w-gallery__current');
    let total = parent.querySelector('.w-gallery__total');

    let totalCount = parent.querySelectorAll('.w-gallery__slide').length;
    let totalDuplicate = parent.querySelectorAll(".swiper-slide-duplicate").length;
    if (total && totalCount) {
      (totalCount+'').length == 1 ? total.innerText = '0'+(totalCount-totalDuplicate) : total.innerText = totalCount-totalDuplicate;
    }

    const slider = new Swiper(container, {
      speed: 500,
      effect: 'fade',
      allowTouchMove: true,
      touchStartPreventDefault: false,
      loop: true,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
          delay: 10000,
      },
      pagination: {
        el: '.w-gallery__pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span></span></span>';
        }
      },
      on: {
        slideChange: function () {
          if (current) {
            let c = this.realIndex+1;
            (c+'').length == 1 ? current.innerText = '0'+c : current.innerText = c;
          }
        },
      }
    });
  }


  function changeBottomHeight() {
    const sliderBottoms = container.querySelectorAll(".w-gallery__slide-bottom");
    const sliderBottomNav = document.querySelector(".w-gallery__bottom");

      sliderBottoms.forEach((sliderBottom) => {
        const textWrapper = sliderBottom.querySelector(".w-gallery__slide-text");
        if (!textWrapper && screen.width < 768) {
          sliderBottom.classList.add("no-text");
          sliderBottomNav.classList.add('no-text');
        }
      })
  }
  function hidelist() {
    const cols = document.querySelectorAll(".lessons_two_blocks__col");
    cols.forEach((col) => {
      const list = col.querySelector(".lessons_two_blocks__list");
      const caption = col.querySelector(".caption");
      const captionHeight = caption.clientHeight;
      
     
        
        col.addEventListener("click", (e) => {
          if (e.target == caption && list.classList.contains("hide") && window.innerWidth < 767) {
            col.style.maxHeight = '';
          } else {
            if (window.innerWidth < 767) {
              col.style.maxHeight = 130 + 'px';
            }
          }
          if (e.target == caption) {
            
            list.classList.toggle("hide");
            caption.classList.toggle("reverse-icon");
          }
          
        })
    })
  } 

  function hideFeaturedList() {
    const wrapper = document.querySelector(".featured-dropdown");
    const title = wrapper.querySelector('.featured__title');
    const list = wrapper.querySelector(".lessons_two_blocks__list");

    title.addEventListener("click", () => {
      list.classList.toggle("hide");
      title.classList.toggle("reverse-icon");
    })
  }
}
